let empty = () => () => {};
export default {
  props: {
    onFile: {
      type: Function,
      default: empty
    },
    onUrl: {
      type: Function,
      default: empty
    },
    onInfo: {
      type: Function,
      default: empty
    },
    onConfirm: {
      type: Function,
      default: empty
    },
    onCancel: {
      type: Function,
      default: empty
    },
    onClose: {
      type: Function,
      default: empty
    }
  },
  data() {
    return {};
  },
  watch: {},
  methods: {}
};
